module.exports = __webpack_public_path__ + "media/images/flags/4x3/guf-193fbc0521a2c04c1cf4c43c539319cc.svg";